// Menu state types
export const MENU_STATES = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
}

// Menu types
export const MENU_TYPES = {
  VIEW_FILES: 'viewFiles',
  HAMBURGER: 'hamburger',
  ACCOUNT: 'account',
  MOBILE_TOP_LEVEL: 'mobileTopLevel',
  SIGN_IN_HAMBURGER: 'signInHamburger',
  CREATE_KIN_CATEGORY: 'createKinCategory',
  SUB_NAV: 'subNav',
  ACCOUNT_MODAL: 'accountModal',
  LG_MODAL: 'lgModal'
}

// Header click types
export const HEADER_CLICK_TYPES = {
  SELECTED_ACCOUNT: 'selectedAccount',
  SELECTED_VIEW_FILES: 'selectedViewFiles',
  SELECTED_VIEW_FILES_DROPDOWN: 'selectedViewFilesDropdown',
  SELECTED_CREATE_KIN_CATEGORY: 'selectedCreateKinCategory',
  SELECTED_CREATE_KIN_CATEGORY_DROPDOWN: 'selectedCreateKinCategoryDropdown',
  SELECTED_MOBILE_TOP_LEVEL: 'selectedMobileTopLevel',
  SELECTED_SIGN_IN: 'selectedSignIn',
  CLOSE_ALL: 'closeAll'
}

// Main category types for mobile navigation
export const MAIN_CATEGORIES = {
  VIEW_FILES: 'viewFiles',
  KIN_CATEGORIES: 'kinCategories',
  BUILD_YOUR_OWN: 'buildYourOwn'
}

// Menu visibility state object structure
export const MENU_VISIBILITY_STRUCTURE = {
  isViewFilesMenuVisible: false,
  isHamburgerMenuVisible: false,
  isAccountMenuVisible: false,
  isMobileTopLevelMenuVisible: false,
  isSignInHamburgerMenuVisible: false,
  isCreateKinCategoryMenuVisible: false,
  isSubNavVisible: false,
  isAccountModalVisible: false,
  isLGModalOpen: false
}

// Menu toggle function names
export const MENU_TOGGLES = {
  TOGGLE_VIEW_FILES_MENU: 'toggleViewFilesMenuVisibility',
  TOGGLE_ACCOUNT_MENU: 'toggleAccountMenuVisibility',
  TOGGLE_CREATE_KIN_CATEGORY_MENU: 'toggleCreateKinCategoryMenuVisibility',
  TOGGLE_HAMBURGER_MENU: 'toggleHamburgerMenuVisibility',
  TOGGLE_SIGN_IN_HAMBURGER_MENU: 'toggleSignInHamburgerMenuVisibility',
  TOGGLE_ACCOUNT_MODAL: 'toggleAccountModal',
  TOGGLE_LG_MODAL: 'toggleLGModal'
}

// Timeout constants
export const TIMEOUT_CONSTANTS = {
  MENU_TIMEOUT_DURATION: 5000, // 5 seconds
  DEBOUNCE_DURATION: 300 // 300ms
}
